import { DateContainer } from "./date-container"
import { LifecycleStateResource, LinkableItemStateResource, WorkflowSchema } from "./workflow-schema"

export enum TaskLifecycleStates {
    FINALIZED = 'finalized',
    IN_PREPARATION = 'inPreparation',
    IN_PROGRESS = 'inProgress',
    PLANNED = 'planned',
}

export interface TaskWorkflowSchema {
    currentState: LifecycleStateResource
    linkableItems: LinkableItemStateResource[]
}

export interface Task {
    id: string,
    title: string,
    taskSchema: {
        applicant: string,
        demandDate: DateContainer,
        limitDate: DateContainer,
    },
    workflowSchema: TaskWorkflowSchema,
}